// @flow
import categoriesData from '../categorySummaryMockData.json';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../../apiTypes';
import type { categorySummaryType } from '../../../types';

export const categorySummaryMock = {
  getSingle: (): Promise<wrappedApiResponseType<categorySummaryType>> => {
    console.log('Called getSingle for category summary');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {},
    });
  },

  getMany: (): djangoModelApiResponse<categorySummaryType> => {
    console.log('Called getMany for category summary');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {
        count: categoriesData.length,
        next: null,
        previous: null,
        results: categoriesData,
      },
    });
  },
};
